class UpdateProductVariant extends HTMLElement {
  constructor() {
    super();
    this.isFreeGift = this.hasAttribute('data-thresholds-gift');
    this.init();
  }

  getVariantData(ELM_cardWrapper) {
    const variantData = JSON.parse(ELM_cardWrapper.querySelector('[type="application/json"]').textContent);
    return variantData;
  }

  updateMasterId(ELM_cardWrapper, currentId) {
    const currentVariant = this.getVariantData(ELM_cardWrapper).find((variant) => variant.id == currentId);
   return currentVariant;
  }

  init() {
    const ELM_cardCompresseds = this.querySelectorAll('.card--show-quick-add');
    ELM_cardCompresseds.forEach(card => {
      const ELM_selectOption = card.querySelector('[name="select-variant"]');
      const ELM_productForm = card.querySelector('product-form form');
      const ELM_price = card.querySelectorAll('.price__container');

      if(!ELM_selectOption) return;
      ELM_selectOption.addEventListener('change', e => {
        const variantId = e?.target?.value;
        const imageId = ELM_selectOption.options[ELM_selectOption.selectedIndex].dataset.imageId;

        if (ELM_productForm && variantId) {
          ELM_productForm.querySelector('[name=id]').value = variantId;

          if (imageId) {
            const ELM_medias = card.querySelectorAll('.media');
            const ELM_selectedMedia = card.querySelector(`#media--${imageId}`);

            if (ELM_selectedMedia) {
              ELM_medias?.forEach(media => {
                media.style.display = 'none'
              });
              ELM_selectedMedia.style.display = 'block';
            }
          }
        }

        const currentVariant = this.updateMasterId(card, variantId);
        if(!ELM_price.length) return;
        ELM_price.forEach(elm => {
          let priceText = currentVariant.price > 0 ? `$${(currentVariant.price / 100).toFixed(0)}` : 'FREE';
          if (priceText === 'FREE') {
            elm.innerHTML = 'FREE';
          } else {
            elm.innerHTML = priceText;
          }

          if (this.isFreeGift) {
            elm.innerHTML = `<div class="price price--on-sale">
              <div class="price__container">
                <div class="price__sale">
                  <span class="price-item price-item--sale price-item--last">FREE</span>
                  <span>
                    <s class="price-item price-item--regular">
                      ${priceText}
                    </s>
                  </span>
                </div>
              </div>
            </div>`;
          }
        });
      });
    });
  }
}

customElements.define('update-product-variant', UpdateProductVariant);
